import { useLabels, useWindowWidthStore } from 'src/StoreDataProvider';
import LeftNavigation from './LeftNavigation';
import { PaginationProps } from './pagination.types';
import RightNavigation from './RightNavigation';

const Pagination: (props: PaginationProps) => JSX.Element = ({
  currentPage,
  numberOfPages,
  onChange,
}) => {
  const onChangeHandler = (toPage: number): void => {
    onChange(toPage);
  };
  const labels = useLabels();
  const windowState = useWindowWidthStore();
  const numberOfPagesShown = windowState.isMobileView ? 3 : 11;
  const pageButtons = Array.from({ length: numberOfPages }, (_, i) => (
    <li key={i}>
      <button
        onClick={() => {
          onChangeHandler(i);
        }}
        className={`pagination__button${currentPage === i ? ' active' : ''}`}
        data-cy={`pagination-page-${i + 1}`}
        aria-label={`${labels.page1} ${i + 1} ${labels.page2}`}
        aria-current={currentPage === i}
      >
        {i + 1}
      </button>
    </li>
  ));
  const pageButtonsToBeDisplayed = pageButtons.reduce(
    (prev: JSX.Element[], cur: JSX.Element, currentIndex) => {
      const clonePrev = [...prev];
      // Half of the shown items, which should be displayed left and right
      // of the current item, so that it is centered
      const half = Math.floor(numberOfPagesShown / 2);
      // How much items overflow to the right
      const outerUpperBorder =
        currentPage + half + 1 > numberOfPages
          ? currentPage + half + 1 - numberOfPages
          : 0;
      // First element on the left side
      const lowerBorder =
        currentPage - half - outerUpperBorder > 0
          ? currentPage - half - outerUpperBorder
          : 0;
      // Last element on the right side
      const upperBorder = lowerBorder + numberOfPagesShown - 1;
      if (currentIndex >= lowerBorder && currentIndex <= upperBorder) {
        return [...clonePrev, cur];
      }
      return [...clonePrev];
    },
    []
  );

  return (
    <nav
      className={
        !windowState.isMobileView ? 'pagination-desktop' : 'pagination-mobile'
      }
      role="navigation"
    >
      <ul className="pagination">
        <LeftNavigation currentPage={currentPage} onClick={onChangeHandler} />
        {pageButtonsToBeDisplayed}
        <RightNavigation
          currentPage={currentPage}
          onClick={onChangeHandler}
          numberOfPages={numberOfPages}
          numberOfPagesShown={numberOfPagesShown}
        />
      </ul>
    </nav>
  );
};

export default Pagination;
